import { render, staticRenderFns } from "./LoadAttrConfig.vue?vue&type=template&id=0a6c1d2f&scoped=true&"
import script from "./LoadAttrConfig.vue?vue&type=script&lang=ts&"
export * from "./LoadAttrConfig.vue?vue&type=script&lang=ts&"
import style0 from "./LoadAttrConfig.vue?vue&type=style&index=0&id=0a6c1d2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c1d2f",
  null
  
)

export default component.exports